<template>
  <router-link
    class="btn_prefill_ai"
    :data-tst="`${tstPrefix}_btn_prefill_ai`"
    :to="{
      name: 'StudySolutions',
      query: {
        ...$route.query,
        dialogs:
          'solfigr-create-custom-solution-dialog_namespace-tmp/primary_instaPrefill-true_mode-createnew',
      },
    }"
  >
    <div
      class="btn_prefill_ai_inner"
      @click.stop="
        e => {
          if (e.ctrlKey || e.metaKey) {
            return
          }
          e.preventDefault()
          $emit('click:prefill')
        }
      "
    >
      <slot> </slot>
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'BtnPrefillAi',
  props: {
    tstPrefix: { type: String, default: () => 'btnprefill' },
  },
  emits: ['click:prefill'],
}
</script>
